<template>
  <section class="singleFeatures" v-if="hasAnyFeatures" id="features">
    <h2 class="singleFeatures-title">Features <br/> & Amenities</h2>
    
    <div class="featuresContainer">
      <div v-if="listing.Content.interior" class="featuresSection">
        <h3 class="featuresSection-title">Interior</h3>
        <div class="featuresSection-content" v-html="marked(listing.Content.interior)"></div>
      </div>

      <div v-if="listing.Content.exterior" class="featuresSection">
        <h3 class="featuresSection-title">Exterior</h3>
        <div class="featuresSection-content" v-html="marked(listing.Content.exterior)"></div>
      </div>

      <div v-if="listing.Content.area" class="featuresSection">
        <h3 class="featuresSection-title">Area</h3>
        <div class="featuresSection-content" v-html="marked(listing.Content.area)"></div>
      </div>

      <div v-if="listing.Content.financial" class="featuresSection">
        <h3 class="featuresSection-title">Financial</h3>
        <div class="featuresSection-content" v-html="marked(listing.Content.financial)"></div>
      </div>

      <h2 class="singleFeatures-title" v-if="listing && listing.Content.rooms">
        Bedroom & bathroom
      </h2>
      <div class="featuresRooms" v-if="listing && listing.Content.rooms" v-html="marked(listing.Content.rooms)">
      </div>
    </div>
  </section>
</template>

<script>
  import marked from 'marked';

  export default {
    props: ['listing'],
    computed: {
      hasAnyFeatures() {
        if (!this.listing?.Content) return false;
        return !!(
          this.listing.Content.interior ||
          this.listing.Content.exterior ||
          this.listing.Content.area ||
          this.listing.Content.financial 
        );
      }
    },
    methods: {
      marked,
    },
  };
</script>

<style lang="scss">
  .singleFeatures {
    padding: 120px 0 0 0;
    display: flex;
    gap: 30px;
    width: 100%;

    @include phone {
      flex-direction: column;
      padding: 40px 0 0 0;
    }
    
   
    &-title {
      font-size: 72px;
      line-height: 77px;
      font-family: 'Adnaya Libre';
      min-width: 495px;

      @include phone {
        font-size: 42px;
        line-height: 48px;
        min-width: 100%;
      }
    
    }
    .featuresContainer {
      width: 100%;
      font-size: 16px;
      line-height: 28px;
      column-count: 2;
      column-gap: 125px;
      font-size: 18px;
      line-height: 28px;

      @include phone {
        column-count: 1;
        column-gap: 0;
        font-size: 16px;
        line-height: 24px;
      }

      .featuresSection {
        break-inside: avoid; 
         margin-bottom: 16px;
        &-title {
          font-weight: bold;
          color: $red;
        }
      }
    }
  
  }
</style>
